<template>
  <div class="download-mobile-page">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="content-wrapper">
        <!-- 产品logo -->
        <div class="product-logo">
          <img :src="logo" alt="七鼠智服" class="logo-img" />
        </div>

        <!-- 标题和描述 -->
        <div class="content-text">
          <h1 class="main-title">下载七鼠智服客户端</h1>
          <p class="description">立即下载，享受高效便捷的AI智能客服平台</p>
        </div>
      </div>

      <!-- 下载按钮 - 固定在底部 -->
      <div class="download-buttons">
        <button class="download-btn android-btn" @click="downloadAndroid">
          下载安卓被控端
        </button>
        <button class="download-btn ios-btn" @click="downloadIOS">
          下载安卓主控端
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import downBg from '../../assets/img/down/mobile/down_bg.png'
import logo from '../../assets/img/down/mobile/logo.png'

export default {
  name: 'DownloadMobile',
  data() {
    return {
      downBg,
      logo
    }
  },
  methods: {
    downloadAndroid() {
      // 下载安卓被控端
      const downloadUrl = 'https://down.zhihuanai.com/%E4%B8%83%E9%BC%A0%E6%99%BA%E6%9C%8D%E5%AE%89%E5%8D%93(%E8%A2%AB%E6%8E%A7%E7%AB%AF).apk'
      this.triggerDownload(downloadUrl, '七鼠智服安卓(被控端).apk')
    },
    downloadIOS() {
      // 下载安卓主控端
      const downloadUrl = 'https://down.zhihuanai.com/%E4%B8%83%E9%BC%A0%E6%99%BA%E6%9C%8D%E5%AE%89%E5%8D%93(%E4%B8%BB%E6%8E%A7%E7%AB%AF).apk'
      this.triggerDownload(downloadUrl, '七鼠智服安卓(主控端).apk')
    },
    triggerDownload(url, filename) {
      // 检测是否为移动端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

      if (isMobile) {
        // 移动端直接打开下载链接
        window.location.href = url

        this.$message({
          message: `正在下载 ${filename}`,
          type: 'success',
          duration: 3000
        })
      } else {
        // PC端使用download属性
        try {
          const link = document.createElement('a')
          link.href = url
          link.download = filename
          link.style.display = 'none'

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.$message({
            message: `正在下载 ${filename}`,
            type: 'success',
            duration: 3000
          })
        } catch (error) {
          console.error('下载失败:', error)
          window.open(url, '_blank')

          this.$message({
            message: '下载已在新窗口中打开',
            type: 'info',
            duration: 3000
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/mobile-responsive.scss' as mobile;

.download-mobile-page {
  min-height: 100vh;
  background: url('../../assets/img/down/mobile/down_bg.png') no-repeat center center;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;

  // 主要内容区域
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: mobile.px2rem(110);
    padding-bottom: mobile.px2rem(150);

    .content-wrapper {
      text-align: center;
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      // 产品logo
      .product-logo {
        margin-bottom: mobile.px2rem(44);

        .logo-img {
          width: mobile.px2rem(98);
          height: mobile.px2rem(98);
          padding: mobile.px2rem(10);
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0px 1px 12px 1px rgba(51, 79, 103, 0.1);
          border-radius: 20px;
        }
      }

      // 文字内容
      .content-text {
        margin-bottom: mobile.px2rem(60);

        .main-title {
          font-size: mobile.px2rem(24);
          font-weight: 800;
          color: #333;
          margin-bottom: mobile.px2rem(12);
        }

        .description {
          font-size: mobile.px2rem(14);
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
      }
    }

    // 下载按钮 - 固定在底部
    .download-buttons {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: mobile.px2rem(28);
      margin: 0 auto;
      padding: 0 mobile.px2rem(20);

      .download-btn {
        width: mobile.px2rem(200);
        height: mobile.px2rem(45);
        border: none;
        border-radius: 4px;
        font-size: mobile.px2rem(16);
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;

        &.android-btn {
          background: #0051FF;
          color: #fff;

          &:hover {
            opacity: 0.9;
            transform: translateY(mobile.px2rem(-1));
          }

          &:active {
            transform: translateY(0);
          }
        }

        &.ios-btn {
          background: #2B2B2B;
          color: #fff;

          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
}
</style>